import type { LinkHref, Url } from "@octopusdeploy/portal-routes";
import type { Location } from "react-router-dom";
export function isUrl(to: Partial<Location> | LinkHref): to is Url {
    return typeof to === "object" && "resolveWithSpaceId" in to;
}
